import { Stack } from "@bookingcom/bui-react";
import React from "react";
export const FilterCount = ({ children, count, attributes }) => {
    return (React.createElement(Stack, { gap: 3, direction: "row" },
        React.createElement(Stack.Item, { grow: true }, children),
        typeof count === "number" ? (React.createElement(Stack.Item, null,
            React.createElement("span", { ...attributes }, count))) : undefined));
};
